import AntSteps, { type StepsProps as AntStepsProps } from "antd/lib/steps";
import clsx from "clsx";

import styles from "./Steps.module.css";

export type StepsProps = AntStepsProps;

export const Steps = ({ className, ...props }: StepsProps) => {
    return <AntSteps className={clsx(styles.steps, className)} {...props} />;
};
